import SlideLastOutline from './SlideLastOutline'

export default SlideLastOutline
// eslint-disable-next-line import/export
export * from './SlideLastOutline'
